module.exports = __webpack_public_path__ + "img/dcim01.2513b265.jpg";